var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAddIcon = function SvgAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.154 9.154h3.77c.588 0 1.076-.488 1.076-1.077V5.923a1.08 1.08 0 00-1.077-1.077h-3.77v-3.77A1.083 1.083 0 008.078 0H5.923c-.589 0-1.077.488-1.077 1.077v3.77h-3.77A1.083 1.083 0 000 5.922v2.154c0 .589.488 1.077 1.077 1.077h3.77v3.77c0 .588.487 1.076 1.076 1.076h2.154c.589 0 1.077-.488 1.077-1.077v-3.77z",
    fill: "currentColor"
  })));
};
export default SvgAddIcon;